export default __webpack_public_path__ + "static/media/icon-reachside.85977cdc.svg";